import React from 'react';

const ContentDisplay = ({ content }) => {
  const copyText = () => {
    navigator.clipboard.writeText(content);
    alert('✅ Copied to clipboard!');
  };

  return (
    <div className="display">
      <div className="header">
        <h3>📝 Generated Content</h3>
        <button onClick={copyText} className="copy">📋 Copy All</button>
      </div>
      
      <div className="content">
        <pre>{content}</pre>
      </div>

      <div className="badge">
        ✅ Compliant with Indian Medical Council Regulations
      </div>
    </div>
  );
};

export default ContentDisplay;
